import React, { useEffect } from "react";
import { X } from "lucide-react";
import { privacyPolicyText, consentText } from "../legal";

/**
 * Модалка-«фото документа» с правовыми текстами клиники.
 * docKey: "privacy" | "consent"
 */
export default function LegalDocModal({ open, docKey, onClose }) {
  useEffect(() => {
    if (!open) return;
    const handler = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", handler);
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", handler);
      document.body.style.overflow = "";
    };
  }, [open, onClose]);

  if (!open) return null;

  const isPrivacy = docKey === "privacy";
  const title = isPrivacy ? "Политика конфиденциальности" : "Согласие на обработку персональных данных";
  const text = isPrivacy ? privacyPolicyText : consentText;

  return (
    <div className="legal-backdrop" onClick={onClose} data-testid={`legal-modal-${docKey}`}>
      <div className="legal-frame" onClick={(e) => e.stopPropagation()}>
        <button className="legal-close" onClick={onClose} aria-label="Закрыть" data-testid="legal-close">
          <X size={20} />
        </button>

        <div className="legal-doc">
          <div className="legal-doc-header">
            <div className="legal-doc-logo">КИТ</div>
            <div className="legal-doc-meta">
              <div className="legal-doc-org">ООО «КИТ»</div>
              <div className="legal-doc-org-sub">ИНН 7604384828 · ОГРН 1227600006875</div>
              <div className="legal-doc-org-sub">г. Ярославль, пер. Малый Московский, д. 1/17, пом. V</div>
            </div>
          </div>
          <div className="legal-doc-divider" />
          <h1 className="legal-doc-title">{title}</h1>
          <div className="legal-doc-text">
            {text.split("\n\n").map((para, i) => (
              <p key={i}>{para.split("\n").map((line, j, arr) => (
                <React.Fragment key={j}>
                  {line}
                  {j < arr.length - 1 && <br />}
                </React.Fragment>
              ))}</p>
            ))}
          </div>
          <div className="legal-doc-footer">
            ООО «КИТ» · Ярославль · {new Date().getFullYear()}
          </div>
        </div>
      </div>
    </div>
  );
}
